import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDiscordBrandedStyle0 = cosmosIconCss;

const CosmosIconDiscordBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDiscordBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '1f60eb1eca2274cc79bd9a8adc091ad1436d5fe2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2a44c20ca83c724202931ff583a0a28d023b547c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9877fba1fd690b1ea319bd808b4a69ef43ef0fce', d: "M17.248 5.143A14.887 14.887 0 0 0 13.534 4a10.44 10.44 0 0 0-.476.967 13.83 13.83 0 0 0-4.12 0c-.142-.33-.301-.653-.476-.967a14.992 14.992 0 0 0-3.717 1.145c-2.35 3.477-2.987 6.868-2.669 10.21a14.97 14.97 0 0 0 4.555 2.287c.369-.496.695-1.022.975-1.573a9.691 9.691 0 0 1-1.536-.733c.13-.094.255-.19.377-.283a10.698 10.698 0 0 0 9.106 0c.123.1.25.197.377.283-.49.29-1.006.535-1.54.735.28.55.607 1.076.976 1.571a14.903 14.903 0 0 0 4.558-2.285c.373-3.876-.639-7.236-2.676-10.214ZM8.01 13.3c-.888 0-1.621-.805-1.621-1.796 0-.992.708-1.804 1.618-1.804.91 0 1.638.813 1.623 1.804-.016.99-.715 1.796-1.62 1.796Zm5.98 0c-.889 0-1.62-.805-1.62-1.796 0-.992.708-1.804 1.62-1.804.912 0 1.634.813 1.618 1.804-.015.99-.713 1.796-1.618 1.796Z", fill: "#5865F2" }))));
    }
    static get style() { return CosmosIconDiscordBrandedStyle0; }
}, [1, "cosmos-icon-discord-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-discord-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-discord-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDiscordBranded$1);
            }
            break;
    } });
}

const CosmosIconDiscordBranded = CosmosIconDiscordBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDiscordBranded, defineCustomElement };
